import * as React from "react";
import ForestStream from "assets/images/about/forest-stream.jpeg";
import PinkCloud from "assets/images/about/pink-cloud.jpeg";
import Snowboarding from "assets/images/about/snowboarding.jpeg";
import SunsetSea from "assets/images/about/sunset-sea.jpeg";

const AUTOPLAY_INTERVAL = 5000;

const photos = [
  {
    src: Snowboarding,
    alt: "Two snowboarders on a snowy mountain",
    position: "50% 55%",
  },
  {
    src: ForestStream,
    alt: "A clear stream running through a mountain forest",
    position: "50% 58%",
  },
  {
    src: SunsetSea,
    alt: "Sunset over the sea and a distant bridge",
    position: "50% 55%",
  },
  {
    src: PinkCloud,
    alt: "A pink cloud above the sea at dusk",
    position: "50% 58%",
  },
];

const AboutCarousel = () => {
  const [activeIndex, setActiveIndex] = React.useState(0);
  const [isHovered, setIsHovered] = React.useState(false);
  const [isFocused, setIsFocused] = React.useState(false);
  const isPaused = isHovered || isFocused;

  React.useEffect(() => {
    if (
      isPaused ||
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    ) {
      return;
    }

    const interval = window.setInterval(() => {
      setActiveIndex((index) => (index + 1) % photos.length);
    }, AUTOPLAY_INTERVAL);

    return () => window.clearInterval(interval);
  }, [activeIndex, isPaused]);

  const showPrevious = () => {
    setActiveIndex((activeIndex - 1 + photos.length) % photos.length);
  };

  const showNext = () => {
    setActiveIndex((activeIndex + 1) % photos.length);
  };

  return (
    <div
      className="about-carousel"
      role="region"
      aria-label="Photos from Ruofan's life"
      aria-roledescription="carousel"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onFocusCapture={() => setIsFocused(true)}
      onBlurCapture={(event) => {
        if (!event.currentTarget.contains(event.relatedTarget as Node)) {
          setIsFocused(false);
        }
      }}
    >
      <div className="about-carousel__viewport">
        {photos.map((photo, index) => (
          <img
            className={`about-carousel__image${
              index === activeIndex ? " is-active" : ""
            }`}
            src={photo.src}
            alt={photo.alt}
            aria-hidden={index !== activeIndex}
            style={{ objectPosition: photo.position }}
            key={photo.src}
          />
        ))}
        <button
          className="about-carousel__button about-carousel__button--previous"
          type="button"
          aria-label="Previous photo"
          onClick={showPrevious}
        >
          ‹
        </button>
        <button
          className="about-carousel__button about-carousel__button--next"
          type="button"
          aria-label="Next photo"
          onClick={showNext}
        >
          ›
        </button>
      </div>
      <div className="about-carousel__dots" aria-label="Choose a photo">
        {photos.map((photo, index) => (
          <button
            className={`about-carousel__dot${
              index === activeIndex ? " is-active" : ""
            }`}
            type="button"
            aria-label={`Show photo ${index + 1}`}
            aria-current={index === activeIndex ? "true" : undefined}
            onClick={() => setActiveIndex(index)}
            key={photo.src}
          />
        ))}
      </div>
    </div>
  );
};

export default AboutCarousel;
